import { takeLatest } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { getCombinedAd } from 'selectors/adCreation';
import { canAccessPricer } from 'selectors/user';
import { getWgToken } from 'selectors/auth';

import * as actions from 'actions/audienceSizer';
import { logUserAction } from 'actions/analytics';

import { fetchAudienceSize, fetchAudienceSizeV2 } from 'api/audienceSizer';
import { audienceSizeFormatter } from 'api/formatter';
import debug from 'debug';
const log = debug('sagas:audience-sizer');

export function* handleFetchAudienceSize() {
  const wgToken = yield select(getWgToken);
  const userCanAccessPricer = yield select(canAccessPricer);
  const ad = yield select(getCombinedAd);
  const payload = JSON.stringify(audienceSizeFormatter(ad));

  const fetcher = userCanAccessPricer ? fetchAudienceSizeV2 : fetchAudienceSize;

  let sizerData;

  try {
    sizerData = yield call(fetcher, payload, wgToken);

    yield put(actions.fetchAudienceSizeSuccess(sizerData));
  } catch (e) {
    log('fetching the audience failed: ' + e.message);
    yield put(actions.fetchAudienceSizeFailed(e));
  }

  if (sizerData) {
    yield put(logUserAction({
      category: 'create_ad_flow',
      label: 'audience_sizer_shown',
      params: {
        request: ad,
        response: sizerData,
      },
    }));
  } else {
    yield put(logUserAction({
      category: 'create_ad_flow',
      label: 'audience_sizer_errored',
      params: {
        request: ad,
      },
    }));
  }
}

export function* watchForFetchAudienceSize() {
  yield call(takeLatest, actions.FETCH_AUDIENCE_SIZE, handleFetchAudienceSize);
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/audienceSizer.js